/**
 * In this class we can provide constants the can used everywhere in the SkyClickPlayer
 */
class ConstantsFactory {

    // Dynamic resolved relative folder path of the loaded SkyClick-Player JavaScript
    public SKYCLICK_SCRIPT_DIR_PATH:string;

    // default prefix for property names of entries in localStorage and cookie
    public NAMESPACE_LOCALSTORAGE_COOKIE:string = 'SkyClickPlayer';

    constructor(){
        this.defineSkyClickDirPath();
    }

    private defineSkyClickDirPath(){
        // *** Solution from: https://stackoverflow.com/a/20823996
        // search for script tag where SkyClick is included
        let dir = document.querySelector('script[src*="skyclick.js"]').getAttribute('src');
        let name = dir.split('/').pop();
        this.SKYCLICK_SCRIPT_DIR_PATH = dir.replace('/'+name,"") + '/';
    }
}

let Constants = new ConstantsFactory();
export default Constants;


// WEBPACK FOOTER //
// ./src/app/utils/Constants.ts